import { Tabs } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { Form } from '@/Core/UI/Form'
import { TabLabel } from '@/Ship/Components/UI/TabLabel/TabLabel'
import { cx } from '@/Ship/Helpers/cssClass'

import { RequestHistoryTab } from '../Components/Tabs/RequestHistoryTab'
import { TaskDelaysTab } from '../Components/Tabs/TaskDelaysTab'
import { TaskRatingsTab } from '../Components/Tabs/TaskRatingsTab'
import { collectAssignments } from '../Helpers/assignmentCollectors'
import { VehicleNeedsEditStore } from '../Stores/VehicleNeedsEditStore'

import { RequestDetailsSection } from './RequestDetailsSection'
import { RequestSummary } from './RequestSummary'
import { VehicleNeeds } from './VehicleNeeds'

import styles from './RequestFormTemplate.module.css'

/**
 * Картка заявки (перегляд, редагування, створення). Перегляд — вкладки: «Інформація»
 * (зведення, дані заявки, потреби з завданнями), затримки, оцінки, історія; редагування
 * і створення — лише вміст «Інформації». Структура однакова в обох режимах, у редагуванні
 * поля й комірки завдань стають інпутами.
 */
export const RequestFormTemplate = observer(({ formContext }: any) => {
    const isView = formContext?.isEditable === false
    // Стор редагування створюється завжди (дешевий): його читає і зведення, і потреби
    const [editStore] = useState(() => new VehicleNeedsEditStore())

    const info = (
        <Form formContext={formContext}>
            <div className={cx(styles, 'root')}>
                <RequestSummary formContext={formContext} editStore={isView ? undefined : editStore} />
                <RequestDetailsSection formContext={formContext} />
                <VehicleNeeds formContext={formContext} editStore={editStore} />
            </div>
        </Form>
    )

    if (!isView) return info

    const assignments = collectAssignments(formContext)
    const delaysCount = assignments.reduce((n, task) => n + (task.delays?.length ?? 0), 0)
    const ratingsCount = assignments.reduce((n, task) => n + (task.driverRatings?.length ?? 0), 0)

    return (
        <Tabs
            items={[
                { key: 'info', label: 'Інформація', children: info },
                {
                    key: 'taskDelays',
                    label: <TabLabel count={delaysCount}>Затримки</TabLabel>,
                    children: <TaskDelaysTab formContext={formContext} />,
                },
                {
                    key: 'taskRatings',
                    label: <TabLabel count={ratingsCount}>Оцінки водія</TabLabel>,
                    children: <TaskRatingsTab formContext={formContext} />,
                },
                {
                    key: 'requestHistory',
                    label: 'Історія',
                    children: <RequestHistoryTab formContext={formContext} />,
                },
            ]}
        />
    )
})
